/**
 * Represents a 2D vector with x and y coordinates
 */
export class Vector2 {
  constructor(public x: number = 0, public y: number = 0) {}

  public static zero(): Vector2 {
    return new Vector2(0, 0);
  }

  public add(other: Vector2): Vector2 {
    return new Vector2(this.x + other.x, this.y + other.y);
  }

  public subtract(other: Vector2): Vector2 {
    return new Vector2(this.x - other.x, this.y - other.y);
  }

  public scale(scalar: number): Vector2 {
    return new Vector2(this.x * scalar, this.y * scalar);
  }

  public magnitude(): number {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }

  public normalize(): Vector2 {
    const mag = this.magnitude();
    if (mag === 0) {
      return Vector2.zero();
    }
    return this.scale(1 / mag);
  }

  public clone(): Vector2 {
    return new Vector2(this.x, this.y);
  }

  public toString(): string {
    return `Vector2(${this.x}, ${this.y})`;
  }
}
